import { ReactNode } from 'react';
import Container from '@mui/material/Container';

interface SharedGpanelGridProps {
  headerActions?: ReactNode;
  children: ReactNode;
}

export default function SharedGpanelGrid({ children }: SharedGpanelGridProps) {
  return (
    <Container
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          pt: 0.5,
          pb: 0,
          px: 0,
          overflow: 'hidden',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      })}
      maxWidth={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        {children}
      </div>
    </Container>
  );
}
